<div class="loading" [ngStyle]="style"></div>
